import React from 'react'
import PropTypes from 'prop-types'

import GoogleMediaFilesPreview from '../../../../GoogleMediaFilesPreview'

import { getLandscapeImageData } from '../HeadlinesSection/helpers'

const LandscapeImageSectionPreview = ({ data }) => {
  const { assets } = data
  const landscapeImageData = getLandscapeImageData(assets)

  return <GoogleMediaFilesPreview assets={landscapeImageData} />
}

LandscapeImageSectionPreview.propTypes = {
  data: PropTypes.object
}

export default LandscapeImageSectionPreview
